<template>
	<article class="home">
		<!-- MainPage Start -->
		<section class="home-container">
			<scope-advert-swiper :swiperImgArray="indexSwiperImg" :swiperWrapClass="swiperClass" :autoPlay="true"></scope-advert-swiper>

			<div class="describe">
				<h3>{{ frequencyModel.LineName }}</h3>
				<p class="red-text">
					<i class="iconfont icon-renminbi"></i>
					<span>{{ totalPrice }}元[体验]</span>
				</p>
				<p class="gray-text">
					<span>{{ submitInfo.bookDate + ' ' + submitInfo.bookTime }}</span>
				</p>
			</div>

			<div @click="triggerMask" class="option_btn">
				<span>选择:套餐</span>
				<i class="iconfont icon-iconfontzhizuobiaozhun19"></i>
			</div>

			<div class="details">
				<div class="addArticle">
					<img src="//www.callmefix.net/api/Event/getImage?type=1&name=42" alt="" />
					<img src="//www.callmefix.net/api/Event/getImage?type=1&name=35" alt="" />
					<h3>客服联系电话：</h3>
					<p>18029902100（黄先生）</p>
					<p>18029902235（钱小姐）</p>
					<p>18029902001（莫小姐）</p>
					<p>18029902098（何小姐）</p>
					<p>0760-88880777 （08:00-18:30）</p>
				</div>
				<span>（往返套餐的返程可指定日期）</span>
				<span>所有预约需提前一天17:00前购买</span>
				<p class="red-text">下单成功后，司机信息会在行程出发前1-2天落实，购买成功后请保持联系电话畅通。</p>

				<span class="jiashou">【加收说明】</span>
				<p>◆定制包车24小时出发，深夜时段：22:00至次日凌晨05:00时间段内出发或到达的加收50元/程。</p>
				<p>◆定制包车适用于中山市所有范围。</p>
				<p>往广州、深圳方向的，三乡镇、神湾镇、坦州镇需加100元，南朗镇、板芙镇、五桂山镇加50元。</p>
				<p>往珠海方向的，古镇镇、小揽镇、南头镇、黄圃镇、东凤镇、三角镇、阜沙镇、民众镇需加50元。</p>
				<p>如果婚车、组织的会议等，在会场外面排着的都是一排排的红旗轿车，场面不要太酷炫了吧~</p>
				<img src="//www.callmefix.net/api/Event/getImage?type=1&name=30" alt="" />
				<p>
					红旗，对于中国人而言，不仅是一个标识，还是一种深深的情怀和神圣的记忆。生在新中国，长在红旗下，终于有幸见识到庐山真面目了。中山候机楼推出一站式机场定制包车服务，服务轿车就是这看似离我们遥不可及的红旗轿车。
				</p>
				<img src="//www.callmefix.net/api/Event/getImage?type=1&name=31" alt="" />
				<p>提供各大机场接送机服务，专为商务公司、航空公司、旅行社等【涉旅企业】提供一站式机场出行解决方案。接送机范围覆盖全中山市哦~</p>
				<img src="//www.callmefix.net/api/Event/getImage?type=1&name=32" alt="" />
				<p>此次中山候机楼接入机场定制包车服务，无需靠站，一站式出行，礼遇快捷、安全、可靠、舒适！让奔波的旅途中，发现更多出行的专属惠益与宽适尊享！</p>
				<p>赶快来pick你心中那款自豪、神圣~想乘坐却一直没机会的红旗车，尽享轻松无忧之旅吧！</p>
				<img src="//www.callmefix.net/api/Event/getImage?type=1&name=33" alt="" />
			</div>
		</section>
		<!-- MainPage End -->

		<footer class="page-footer"><button @click="triggerMask">下一步</button></footer>

		<!-- MaskOption Start -->
		<section :class="[showMask ? 'show' : '', 'mask-wrap']" @click.self="triggerMask">
			<transition name="showmask-ordermodel">
				<div v-if="showMask" :class="['mask-container']">
					<header>
						<div class="thumbnail-wrap"><img src="//www.callmefix.net/api/Event/getImage?type=1&name=30" alt="" /></div>
						<div class="text-description">
							<h3>各大站点,欢迎预约!</h3>
							<p class="red-text">
								<i class="iconfont icon-renminbi"></i>
								<span>{{ totalPrice }}</span>
							</p>
						</div>
						<div @click.stop="triggerMask" class="del-icon-wrap"><i class="iconfont icon-shanchu2"></i></div>
					</header>

					<section class="select-container-wrap">
						<div class="select-item-wrap">
							<!-- <div class="ticket-form">
								<h3>车型 :</h3>
								<button v-for="(item,index) in carTypes" @click="carTypeActive(index)" :class="[currentCarType === index?'active':'']">{{item.name}}</button>
							</div> -->
							<!-- 			        		<div class="airport-wrap">
			            		<h3>城市 :</h3>
			            		<div class="airport-items">
			              			<button :class="[currentCity == index?'active':'']" v-for="(item,index) in cityList" @click="cityActive(item,index)" :key="index">{{item.name}}</button>
			            		</div>
			          		</div> -->
							<div class="airport-wrap">
								<h3>目的地 :</h3>
								<div class="airport-items">
									<button :disabled="true" class="active">{{ airport }}</button>
								</div>
							</div>
							<div class="car-model">
								<h3>行程类型 :</h3>
								<button v-for="(item, index) in goTypeModels" :class="[currentGoType === index ? 'active' : '']" :disabled="true" :key="index">
									{{ item.name }}
								</button>
							</div>
							<div class="ticket-form">
								<h3>用车方式 :</h3>
								<button v-for="(item, index) in timeTypesModels" :key="index" :class="[currentTimeType === index ? 'active' : '']" :disabled="true">
									{{ item.name }}
								</button>
							</div>
							<div class="ticket-form">
								<h3>特别镇区加收:</h3>
								<button
									v-for="(item, index) in extraDistrict"
									@click="extraDistrictActive(index)"
									:class="[currentExtraDistrict === index ? 'active' : '']"
									v-if="extraDistrict[index].belongsTo.indexOf(airport) != -1"
									:key="index"
								>
									{{ item.name }}
								</button>
							</div>
						</div>

						<div class="goods-amount">
							<span>乘坐人数 :</span>
							<div class="selector">
								<i @click="subGoods(1)" :class="['iconfont', 'icon-jianhao', submitInfo.goodsCount == 1 ? 'disabled' : '']"></i>
								<input v-model="submitInfo.goodsCount" type="number" disabled="true" />
								<i @click="addGoods(1)" :class="['iconfont', 'icon-jiahao', submitInfo.goodsCount > 9 ? 'disabled' : '']"></i>
							</div>
						</div>

						<div :class="['link-man-wrap']">
							<span>
								<em style="color: #E22222;">*</em>
								联系人
							</span>
							<input v-model="submitInfo.linkMan" placeholder="请输入联系人" type="text" />
						</div>

						<div :class="['phone-num-wrap']">
							<span>
								<em style="color: #E22222;">*</em>
								联系电话
							</span>
							<input v-model="submitInfo.phone" placeholder="输入您的联系电话" type="number" />
						</div>

						<div :class="['user-site']">
							<span>
								<em style="color: #E22222;">*</em>
								{{ frequencyModel.IsGo ? '上门接送地址' : '返程到达地址' }}
							</span>
							<input v-model="submitInfo.address" placeholder="请填写接送地址" type="text" />
						</div>

						<div class="date-picker">
							<span>
								<em style="color: #E22222;">*</em>
								用车日期
							</span>
							<span :class="[submitInfo.bookDate == '' ? 'gray-text' : '']">{{ submitInfo.bookDate }}</span>
						</div>

						<div class="time-picker">
							<span>
								<em style="color: #E22222;">*</em>
								用车时间
							</span>
							<span :class="[submitInfo.bookTime == '' ? 'gray-text' : '']">{{ submitInfo.bookTime }}</span>
						</div>
						<div :class="['leave-msg']">
							<span>
								<em style="color: #E22222;"></em>
								航班号
							</span>
							<input v-model="submitInfo.flightNumber" placeholder="请填写航班号" type="text" />
						</div>
						<div :class="['leave-msg']">
							<span>
								<em style="color: #E22222;">*</em>
								备注
							</span>
							<input v-model="submitInfo.remarks" placeholder="请注明人数行李件数和特别要求" type="text" />
						</div>
					</section>

					<footer class="mask-footer"><button @click="goToSubmitOrder">下一步</button></footer>
				</div>
			</transition>
		</section>
		<!-- MaskOption End -->
	</article>
</template>

<script>
import scopeApi from '../request/scopeApi';
import orderApi from '../request/orderApi';
import frequencyApi from '../request/frequencyApi';
import addressApi from '../request/addressApi';
import ScopeAdvertSwiper from './child-components/ScopeAdvertSwiper';
import ScopeMaskOption from './child-components/ScopeMaskOption';
import ScopeContentFooter from './child-components/ScopeContentFooter';
import { mapState } from 'vuex';
export default {
	name: 'MakeSpecialCarOrder',
	components: {
		ScopeAdvertSwiper
	},
	data() {
		return {
			indexSwiperImg: [
				'//www.callmefix.net/api/Event/getImage?type=1&name=42',
				'//www.callmefix.net/api/Event/getImage?type=1&name=30',
				'//www.callmefix.net/api/Event/getImage?type=1&name=31',
				'//www.callmefix.net/api/Event/getImage?type=1&name=32',
				'//www.callmefix.net/api/Event/getImage?type=1&name=33'
			],
			swiperClass: 'big_banner_wrap',
			showMask: true,

			frequencyId: '',
			frequencyModel: {},
			canEntry: true,

			// maskoption
			//用户输入的资料
			submitInfo: {
				linkMan: '',
				phone: '',
				address: '',
				bookDate: '',
				bookTime: '',
				goodsCount: 1,
				goodsName: '',
				goodsPrice: 0,
				remarks: '',
				flightNumber: '',
				getOff: ''
			},
			goTypeModels: [
				{
					id: 1,
					name: '中山出发',
					isUsed: true
				},
				{
					id: 2,
					name: '返程中山',
					isUsed: true
				}
			],
			timeTypesModels: [
				{
					id: 1,
					name: '常规时间5:00-22:00',
					extra: 0,
					isUsed: true
				},
				{
					id: 2,
					name: '单程深夜22:00-5:00',
					extra: 50,
					isUsed: true
				}
			],
			extraDistrict: [
				{
					id: 1,
					name: '城区及非指定镇区',
					belongsTo: '广州机场,广州南站,深圳机场,珠海机场,横琴口岸,港珠澳大桥口岸,拱北口岸,蛇口港,深圳湾口岸,罗湖口岸,皇岗口岸,佛山机场',
					Price: 0
				},
				{
					id: 2,
					name: '三乡镇｜神湾镇｜坦州镇',
					belongsTo: '广州机场,广州南站,深圳机场,蛇口港,深圳湾口岸,罗湖口岸,皇岗口岸',
					Price: 100
				},
				{
					id: 3,
					name: '南朗镇｜板芙镇｜五桂山街道',
					belongsTo: '广州机场,广州南站,深圳机场,蛇口港,深圳湾口岸,罗湖口岸,皇岗口岸',
					Price: 50
				},
				{
					id: 4,
					name: '古镇镇｜小榄镇｜南头镇｜黄圃镇｜东凤镇｜三角镇｜阜沙镇｜民众镇',
					belongsTo: '珠海机场,横琴口岸,港珠澳大桥口岸,拱北口岸',
					Price: 50
				}
			],
			currentGoType: 0,
			currentTimeType: 0,
			currentExtraDistrict: 0,
			airport: '',
			carModel: '红旗HS3'
			// maskoption
		};
	},
	activated() {
		this.getRouterValue();
		if (this.frequencyId && this.frequencyId != '') {
			this.getFrequencyInfo();
		}
	},
	mounted() {
		this.getUserDefaultAddress();
		document.body.addEventListener('focusout', () => {
			window.scrollTo({
				top: 0,
				left: 0,
				behavior: 'smooth'
			});
		});
	},
	methods: {
		getRouterValue() {
			if (this.$route.params.frequencyId && this.$route.params.frequencyId != '') {
				this.frequencyId = this.$route.params.frequencyId;
			}
		},
		getFrequencyInfo() {
			frequencyApi.getFrequencyInfo(this.frequencyId).then(sucRes => {
				sucRes.data.SetTime = sucRes.data.SetTime.replace('T', ' ');
				this.frequencyModel = sucRes.data;
				this.checkFrequencyCanEntry();
			});
		},
		checkFrequencyCanEntry() {
			if (this.frequencyModel.NowMember > 0) {
				this.canEntry = false;
				alert('该专车线路已售完！');
				wx.miniProgram.getEnv(function(res) {
					if (res.miniprogram) {
						wx.miniProgram.navigateBack();
					}
				});
			} else {
				this.canEntry = true;
				this.setRealParams();
			}
		},
		setRealParams() {
			this.airport = this.frequencyModel.LineName.split('-')[1];
			this.submitInfo.bookDate = this.frequencyModel.SetTime.split(' ')[0];
			let timeArr = this.frequencyModel.SetTime.split(' ')[1].split(':');
			this.submitInfo.bookTime = timeArr[0] + ':' + timeArr[1];
			let hour = this.submitInfo.bookTime.split(':')[0];
			if (hour > 4 && hour < 22) {
				this.currentTimeType = 0;
			} else this.currentTimeType = 1;
			this.currentGoType = this.frequencyModel.IsGo ? 0 : 1;
		},
		subGoods(dec) {
			if (this.submitInfo.goodsCount > 1) {
				this.submitInfo.goodsCount -= dec;
			} else if (this.submitInfo.goodsCount == 1) {
				alert('乘坐人数不能少于1');
			}
		},
		addGoods(inc) {
			if (this.submitInfo.goodsCount < 4) {
				this.submitInfo.goodsCount += inc;
			} else {
				alert('最多乘坐4人哦!');
			}
		},
		getUserDefaultAddress() {
			var that = this;
			addressApi.getAddressList(this.$store.state.user.OpenId, '').then(sucRes => {
				var result = sucRes.body;
				if (sucRes.success && sucRes.data.length > 0) {
					for (var i = 0; i < sucRes.data.length; i++) {
						if (sucRes.data[i].IsDefault) {
							var tmp = sucRes.data[i];
							this.submitInfo.linkMan = tmp.Contact;
							this.submitInfo.phone = tmp.Mobile;
							this.submitInfo.address = tmp.District + tmp.Address;
							break;
						}
					}
				}
			});
		},
		triggerMask() {
			this.showMask = !this.showMask;
			console.log(this.showMask);
		},
		goToSubmitOrder() {
			var linkManReg = /^[\u4e00-\u9fa5_a-zA-Z ]{2,20}$/,
				phoneReg = /^[1][3,4,5,7,8][0-9]{9}$/,
				linkManBoolean = linkManReg.test(this.submitInfo.linkMan),
				phoneBoolean = phoneReg.test(this.submitInfo.phone);

			if (this.submitInfo.linkMan && this.submitInfo.phone && this.submitInfo.bookDate != '' && this.submitInfo.bookTime != '') {
				if (linkManBoolean) {
					if (phoneBoolean && this.submitInfo.phone.length > 7) {
						if (phoneBoolean && linkManBoolean) {
							if (this.submitInfo.address == '') {
								this.$Message.warning('请填写去程上门接送地址、返程到达地址！');
								return;
							}
							this.submitInfo.getOff = this.airport;
							this.submitInfo.goodsName = `${this.carModel}-${this.airport}-${this.goTypeModels[this.currentGoType].name}-${
								this.currentTimeType == 0 ? '常规时间' : '单程深夜时间'
							}-${this.currentExtraDistrict == 0 ? '非加收区域' : '镇区加收'}`;
							this.submitInfo.goodsPrice = this.totalPrice;
							console.log(this.submitInfo);
							this.$router.push({
								name: 'CreateSpecialCarOrder',
								params: {
									submitInfo: this.submitInfo,
									frequencyId: this.frequencyId
								}
							});
						}
					} else {
						this.$Message.warning('手机号码不合法');
					}
				} else {
					this.$Message.warning('名字不合法');
				}
			} else {
				this.$Message.warning('请补充填写完整资料');
			}
		},
		extraDistrictActive(index) {
			this.currentExtraDistrict = index;
		}
	},
	computed: mapState({
		DefaultAddress: state => state.ticket.DefaultAddress,
		cityName: state => state.appoint.CityName,
		Location: state => state.user.Location,
		totalPrice() {
			let total = 0;
			let basePrice = this.frequencyModel.CharteredPrice;
			let timePrice = this.timeTypesModels[this.currentTimeType].extra;
			let extraDistrictPrice = this.extraDistrict[this.currentExtraDistrict].Price;
			total = basePrice + timePrice + extraDistrictPrice;
			return total;
		}
	})
};
</script>

<style>
@import '../style/css/specialcar.css';
@import '../style/css/specialcarpublic.css';
@import '../style/css/specialcariconfont.css';
@import '../style/css/specialcarreset.css';
@import '../style/css/specialcarvariable.css';
</style>



// WEBPACK FOOTER //
// src/components/MakeSpecialCarOrder.vue